import React, { useState } from 'react';
import { getPlayerInitials, getTeamColor } from '../utils/playerImage';

/**
 * PlayerAvatar Component
 * 
 * Displays player avatar - tries to load local image, falls back to initials
 */
const PlayerAvatar = ({ player, size = 'small', className = '' }) => {
  const [imageError, setImageError] = useState(false);
  
  if (!player) return null;
  
  // Size configurations
  const sizeClasses = {
    small: 'w-12 h-12 text-lg',
    medium: 'w-16 h-16 text-xl',
    large: 'w-32 h-32 text-4xl',
    xlarge: 'w-40 h-40 text-5xl'
  };
  
  const sizeClass = sizeClasses[size] || sizeClasses.small;
  
  // Generate player slug and image path
  const playerSlug = `${player.firstName}-${player.lastName}`.toLowerCase().replace(/\s+/g, '-');
  const localImagePath = `/images/players/${playerSlug}.png`;
  
  // Fallback initials
  const initials = getPlayerInitials(player);
  const bgColor = getTeamColor(player.team);
  
  // If image failed to load or doesn't exist, show initials
  if (imageError) {
    return (
      <div 
        className={`${sizeClass} ${className} rounded-full flex items-center justify-center text-white font-bold shadow-lg dark:shadow-gray-900 ring-2 ring-gray-200`}
        style={{ 
          backgroundColor: bgColor,
          backgroundImage: `linear-gradient(135deg, ${bgColor} 0%, ${bgColor}dd 100%)`
        }}
        title={`${player.firstName} ${player.lastName}`}
      >
        {initials}
      </div>
    );
  }
  
  // Try to load the image
  return (
    <img
      src={localImagePath}
      alt={`${player.firstName} ${player.lastName}`}
      className={`${sizeClass} ${className} rounded-full object-cover shadow-lg dark:shadow-gray-900 border-2 border-white`}
      onError={() => setImageError(true)}
      title={`${player.firstName} ${player.lastName}`}
    />
  );
};

export default PlayerAvatar;
